import { Tabs, Tab, AppBar, useTheme  } from "@material-ui/core"
import {a11yProps} from "../helpers/a11y"
import {useUser} from "../../contexts/UserContext"

export default function ModeTabs({index, setIndex}) {
  const theme = useTheme();
  const {user} = useUser()
  const borderColor = theme.palette.mode === 'light' ? '#d6d6d6' : '#424242';

  const tabs = [
    { label: "Authorizations", index: 0 },
    ...(user.admin ? [{ label: "Intake", index: 1 }] : []),
    { label: "Processing", index: user.admin ? 2 : 1 },
    { label: "Review", index: user.admin ? 3 : 2 },
  ];

  return(
    <AppBar position="static" color="default">
      <Tabs   
        centered 
        indicatorColor="primary" 
        value={index} 
        style={{borderBottom: `1px solid ${borderColor}`}}
        onChange={(e, val) => setIndex(val)}>
        {tabs.map((tab) => (
          <Tab
            key={tab.index}
            label={tab.label}
            {...a11yProps(tab.index)}
          />
        ))}
      </Tabs>
    </AppBar>
  )
}